import { z } from 'zod';
import { CustomErrorParams, CustomErrorType } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export enum WhitelistedEmailConfigurationField {
    Email = 'email',
    EmailTypes = 'emailTypes',
}

interface WhitelistedEmailConfigurationSchemaProps {
    availableEmails: string[];
}

const createValidEmailsSchema = (availableEmails: string[]) =>
    z
        .string()
        .email()
        .refine((value) => availableEmails.includes(value), {
            params: {
                errorType: CustomErrorType.Other,
                textKey: TextKey.WhitelistedUserEmailsAddEmailNotFoundError,
            } satisfies CustomErrorParams,
        });

export const createWhitelistedEmailConfigurationSchema = ({
    availableEmails,
}: WhitelistedEmailConfigurationSchemaProps) =>
    z.object({
        [WhitelistedEmailConfigurationField.Email]: createValidEmailsSchema(availableEmails),
        [WhitelistedEmailConfigurationField.EmailTypes]: z.array(z.string()).nonempty(),
    });

export type WhitelistedEmailConfigurationModel = z.infer<ReturnType<typeof createWhitelistedEmailConfigurationSchema>>;
